import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useSignUp = () => {
  const [state, setState] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const navigate = useNavigate();

  const handleChange = (e, field) => {
    setState((state) => ({ ...state, [field]: e.target.value }));
  };

  const signInHandler = () => {
    navigate("/login");
  };

  return {
    state,
    handleChange,
    signInHandler,
  };
};
